import { QueryFunctionContext } from '@tanstack/react-query'
import { DELETE, GET, POST, PUT } from '../../../redux/middleware/types'
import backendRequest from '../../../services/api/backendRequest'
import reallocationEndpoints from '../api/reallocationEndpoints'
import reallocationQueryKeys from '../queries/reallocationQueryKeys'
import { ReallocationSource, ReallocationTarget } from '../../../types/reallocation/Reallocation'

export const fetchReallocations = async ({
  queryKey: [{ companyId }],
  signal
}: QueryFunctionContext<ReturnType<(typeof reallocationQueryKeys)['list']>>): Promise<ReallocationSource[]> => {
  if (!companyId) return []
  return backendRequest<ReallocationSource[]>({
    method: GET,
    url: reallocationEndpoints.list(companyId),
    signal
  })
}

export const createReallocation = async (data: ReallocationSource, companyId: string): Promise<ReallocationSource> => {
  return backendRequest<ReallocationSource>({
    method: POST,
    url: reallocationEndpoints.list(companyId),
    data
  })
}

export const updateReallocation = async (data: ReallocationSource, companyId: string): Promise<ReallocationSource> => {
  return backendRequest<ReallocationSource>({
    method: PUT,
    url: reallocationEndpoints.detail(companyId, data.id),
    data
  })
}

export const deleteReallocation = async (
  companyId: string,
  id: ReallocationSource['id']
): Promise<ReallocationSource> => {
  return backendRequest<ReallocationSource>({
    method: DELETE,
    url: reallocationEndpoints.detail(companyId, id)
  })
}

export const createReallocationTarget = async (
  data: ReallocationTarget,
  companyId: string,
  sourceId: ReallocationSource['id']
): Promise<ReallocationTarget> => {
  return backendRequest<ReallocationTarget>({
    method: POST,
    url: reallocationEndpoints.targets(companyId, sourceId),
    data
  })
}

export const updateReallocationTarget = async (
  data: ReallocationTarget,
  companyId: string,
  sourceId: ReallocationSource['id']
): Promise<ReallocationTarget> => {
  return backendRequest<ReallocationTarget>({
    method: PUT,
    url: reallocationEndpoints.target(companyId, sourceId, data.id),
    data
  })
}

export const deleteReallocationTarget = async (
  companyId: string,
  sourceId: ReallocationSource['id'],
  targetId: ReallocationTarget['id']
): Promise<ReallocationTarget> => {
  return backendRequest<ReallocationTarget>({
    method: DELETE,
    url: reallocationEndpoints.target(companyId, sourceId, targetId)
  })
}
